import { Component, OnInit } from '@angular/core';
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, SwiperOptions } from 'swiper';
// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

@Component({
  selector: 'app-reschedule-page',
  templateUrl: './reschedule-page.component.html',
  styleUrls: ['./reschedule-page.component.css']
})
export class ReschedulePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  config: SwiperOptions = {
    pagination: false,
    scrollbar: false,
    //allowTouchMove: false,
    breakpoints: {
      320: {
        slidesPerView: 3.2,
        spaceBetween: 20,
        navigation: false,
      },
      768: {
        slidesPerView: 5.5,
        spaceBetween: 20,
        navigation: false,
      },
      992: {
        slidesPerView: 7,
        spaceBetween: 15,
        navigation: true,
      }
    }
  };

}
